import React from "react";
import { FontIcon } from "react-md";

const FormInputIcon = ({ children }) => (
  <div className="form-input-icon">
    <FontIcon>{children}</FontIcon>
  </div>
);

export default FormInputIcon;



// WEBPACK FOOTER //
// ./src/common/components/FormInputIcon.jsx